export enum NewAlarmSound {
  None = 'none',
  Default = 'default',
  Train = 'train',
}
